import RetractableSidebar from "../../home/components/Retractable.Sidebar";
import Link from "admin/shared/ui/Link.Component";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import RegisterIcon from "@material-ui/icons/BorderColor";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import { compose } from "redux";
import amlConnector from "../../../services/aml/amlConnector";
import "./Aml.scss";

const AmlComponent = ({ children }) => {
  return (
    <div className="wrapper-style-aml-menu">
      <RetractableSidebar storageKey="Aml">
        <List>
          <ListItem disabled={true}>
            <ListItemText primary="Aml:" />
          </ListItem>
          <Link activeClassName="active-style" toState={"amlWarnings"}>
            <ListItem button>
              <ListItemIcon>
                <RegisterIcon />
              </ListItemIcon>
              <ListItemText primary="Warnings" />
            </ListItem>
          </Link>
          <Link activeClassName="active-style" toState={"amlRules"}>
            <ListItem button>
              <ListItemIcon>
                <RegisterIcon />
              </ListItemIcon>
              <ListItemText primary="Rules" />
            </ListItem>
          </Link>
        </List>
      </RetractableSidebar>
      <div className="div-style1">
        <div className="body-height content-padding">{children}</div>
      </div>
    </div>
  );
};

export default compose(amlConnector)(AmlComponent);
